import React, { useContext, useEffect, useState, Suspense } from 'react';
import Layout from '../../../components/Layout/LayoutV2/Layout';
import { PageContext } from '../../../contexts/ContextCreator';
import { Provider as CommunityContextProvider } from '../../../contexts/CommunityContext';
import './PodcastPage.scss';
import { CommunityContentLandingPage } from '../../../components/Community/SingleContent/CommunityContentDisplayV2/CommunityContentLandingPage';
import { CommunityContentProvider } from '../../../components/Community/SingleContent/CommunityContentDisplayV2/CommunityContentContext';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';

const GoogleOneTap = React.lazy(() =>
    import('../../../components/Login/GoogleOneTap/GoogleOneTap')
);

const PodcastPage = (props) => {
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);

    const { content, recentContent } = props;

    const { isLoggedIn, pageProps } = useContext(PageContext);

    const showGoogleoneTapLogin = () => {
        return (
            typeof window !== 'undefined' &&
            window?.document?.referrer.includes('google') &&
            !isLoggedIn()
        );
    };

    const constructCommunityContentkey = () =>
        `${props.content.type}-${props.content.hash}`;

    return (
        <CommunityContextProvider
            singleAttributionContentHash={props.content.hash}
            attributionMode="single"
            content={[content]}
            topics={props?.topics}
        >
            <SnowplowPageViewTracker
                pageEntityId={constructCommunityContentkey()}
                pageType={PAGE_VIEW_TYPES.CONTENT}
                pageSection={PAGE_VIEW_SECTIONS.ADVICE}
            />
            <div>
                {isMounted && showGoogleoneTapLogin() && (
                    <Suspense fallback={null}>
                        <GoogleOneTap gclientId={pageProps.googleClientId} />
                    </Suspense>
                )}
                <Layout
                    {...props}
                    topBannerOnlyShownList={['admin-onboard']}
                    className={props.group?.groupUrl ? 'groups-layout' : ''}
                >
                    <CommunityContentProvider
                        content={content}
                        recentContent={recentContent}
                    >
                        <CommunityContentLandingPage />
                    </CommunityContentProvider>
                </Layout>
            </div>
            )
        </CommunityContextProvider>
    );
};

export default PodcastPage;
